import { CommandBar, CommandBarLink, CommandBarContainer } from 'components/layout/CommandBar';
import { PageHeader } from 'components/layout/PageHeader';
import { usePermissions, UserPermission, WriteOn } from 'modules/permissions';

interface OpportunityListHeaderProps {
   toggleFilterBar: () => void;
}

export const OpportunitiesListHeader = ({ toggleFilterBar }: OpportunityListHeaderProps) => {
   const { hasPermission } = usePermissions();

   const items = () => {
      return hasPermission(WriteOn(UserPermission.NewObservation))
         ? [
              {
                 key: 'newObservation',
                 text: 'Report a new Observation',
                 data: {
                    link: '/observation/new'
                 },
                 iconProps: { iconName: 'Add' },
                 commandBarButtonAs: CommandBarLink
              }
           ]
         : [];
   };

   return (
      <>
         <PageHeader>Opportunities - Overview</PageHeader>

         <CommandBarContainer>
            <CommandBar
               items={items()}
               farItems={[
                  {
                     key: 'filter',
                     text: 'Filter',
                     cacheKey: 'filter',
                     iconProps: { iconName: 'Filter' },
                     iconOnly: true,
                     onClick: toggleFilterBar
                  }
               ]}
            />
         </CommandBarContainer>
      </>
   );
};
